import type { WorksheetModule, WorksheetSize } from "@arbeidsark/shared"
import range from "lodash/range"
import styled from "styled-components"
import GenericLanguagePageConfiguration from "./GenericLanguagePageConfiguration"

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 1.15rem;
  gap: 1.15rem;

  padding-bottom: 3rem;
`

export interface GenericLanguagePageConfigurationListProps {
  numberOfPages: number
  pagesConfiguration?: Record<string, Record<string, WorksheetModule>>
  layout: WorksheetSize
  onPageModuleConfigurationChanged: (
    page: number,
    moduleNumber: number,
    moduleConfiguration: WorksheetModule,
  ) => void
  onRegenerateModule: (page: number, moduleNumber: number) => void
}

const GenericLanguagePageConfigurationList: React.FC<
  GenericLanguagePageConfigurationListProps
> = ({
  numberOfPages,
  pagesConfiguration,
  layout,
  onPageModuleConfigurationChanged,
  onRegenerateModule,
}) => {
  return (
    <Layout>
      {range(numberOfPages).map((page) => (
        <GenericLanguagePageConfiguration
          key={page}
          pageIndex={page}
          layout={layout}
          modulesConfiguration={pagesConfiguration?.[page]}
          onConfigurationChanged={(moduleIndex, configuration) => {
            onPageModuleConfigurationChanged(page, moduleIndex, configuration)
          }}
          onRegenerateModule={(moduleIndex) =>
            onRegenerateModule(page, moduleIndex)
          }
          isFirstPage={page === 0}
        />
      ))}
    </Layout>
  )
}

export default GenericLanguagePageConfigurationList
